import React, { useRef, useEffect } from "react";
import {
  isInvalidNumericKey,
  sanitizeNumericString,
} from "../utils/textUtils";

/**
 * Quantity and Unit input controls
 */
const QuantityUnitControls = ({
  quantity,
  unit,
  unitOptions,
  onQuantityChange,
  onUnitChange,
  disabled = false,
  autoFocus = false, // New prop to control auto-focus
}) => {
  const qtyInputRef = useRef(null);

  // Auto-focus qty input when component mounts or autoFocus prop changes
  useEffect(() => {
    if (autoFocus && qtyInputRef.current && !disabled) {
      // Use setTimeout to ensure the input is rendered and visible
      setTimeout(() => {
        qtyInputRef.current?.focus();
        qtyInputRef.current?.select(); // Select any existing text
      }, 100);
    }
  }, [autoFocus, disabled]);

  const handleQuantityKeyDown = (e) => {
    if (isInvalidNumericKey(e.key)) {
      e.preventDefault();
    }
  };

  const handleQuantityChange = (e) => {
    const rawValue = e.target.value;
    const value = sanitizeNumericString(rawValue);

    if (value !== rawValue) {
      e.target.value = value;
    }

    onQuantityChange(e);
  };

  return (
    <>
      {/* Quantity Input */}
      <input
        ref={qtyInputRef}
        type="number"
        value={quantity || ""}
        onChange={handleQuantityChange}
        onKeyDown={handleQuantityKeyDown}
        placeholder="Enter quantity"
        disabled={disabled}
        maxLength={4}
        max={9999}
        min={1}
        style={{
          padding: "5px",
          fontSize: "12px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          marginBottom: "10px",
          width: "100%",
        }}
      />

      {/* Unit Dropdown */}
      <div style={{ marginBottom: "10px" }}>
        <select
          value={unit || ""}
          onChange={onUnitChange}
          disabled={!quantity || Number(quantity) <= 0}
          style={{
            padding: "5px",
            fontSize: "12px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            width: "100%",
          }}
        >
          <option value="">Select unit</option>
          {unitOptions.flatMap(
            (unitType) =>
              unitType.unit_type_for_name?.map((unitItem) => (
                <option key={unitItem.unit_id} value={unitItem.unit_name}>
                  {unitItem.unit_name}
                </option>
              )) || []
          )}
        </select>
      </div>
    </>
  );
};

export default QuantityUnitControls;
